import { useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPEHOLIDAYS = 'holidays';
const keysFactory = {
    holidays: (year, financingProgram) => [{ scope: SCOPEHOLIDAYS, year, financingProgram }],
};
const createGetHolidaysForYear = (financingProgram) => {
    return async ({ queryKey: [{ year }] }) => {
        const response = await apiClient.get(`${financingProgram}/Holidays/${encodeURIComponent(year)}`);
        return response.data;
    };
};
export function useGetHolidaysForYear(year, financingProgram) {
    const getHolidaysForYear = createGetHolidaysForYear(financingProgram);
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.holidays(year, financingProgram),
        queryFn: getHolidaysForYear,
    });
    return [data?.holidays ?? null, isFetching];
}
